// extracted by mini-css-extract-plugin
export default {"container":"TablePlate_container__Dz5tD","table":"TablePlate_table__uMIk2","align_right":"TablePlate_align_right__TjVIP","small-height":"TablePlate_small-height__y09xe"};